<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
            :busy="isLoading"
            head-variant="light"
            :no-local-sorting="true"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            per-page="0"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :sticky-header="height"
            no-border-collapse
            responsive
            show-empty
            empty-text="Non ci sono record da mostrare"
            small
            @sort-changed="sortingChanged"
            :tbody-tr-class="rowClass"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newFattuttoConfigBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea una
                  nuova Configurazione cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create px-3"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewFattuttoConfig"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <base-icon name="circled_plus" width="22" height="22" />
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template
            >
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                  size="sm"
                  variant="lisaweb"
                  @click="openModal(row.item, row.index, $event.target)"
                  title="Modifica"
                  :disabled="!!row.item.read_only"
              >
                <base-icon name="edit"></base-icon>
              </b-button>
            </div>
          </template>
          <template v-slot:[fattuttoEntityCode]="row">
            <!-- <pre>{{ row.item }}</pre> -->
            {{ renderEntityCode(row.item) }}
            <!-- <template
              v-if="
                Object.prototype.hasOwnProperty.call(
                  row.item.fattutto_transmission,
                  'record'
                ) &&
                ![0, 1, 5, 6].includes(
                  row.item.fattutto_transmission.transmission_status
                )
              "
            >
              {{
                `${getNestedValue(
                  row.item,
                  fattutto_records_sent
                )} / ${getNestedValue(row.item, fattutto_records)}`
              }}
            </template>
            <span v-else>-</span> -->
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
          :id="infomodalName"
          :dialog-class="customModalClass"
          :title="custoModalTitle"
          size="lg"
          scrollable
          ok-only
          ok-title="Chiudi"
          ok-variant="-transparent"
          header-bg-variant="lisaweb"
          no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14"/>
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
                v-for="(tab, index) in tabs"
                :key="index"
                @click="setTab(tab, index)"
                :title="tab.text"
                :active="index === tabIndex"
                title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                    v-if="selected === tab.name"
                    :is="selected"
                    :resourceId="modalResourceId"
                    :dbRowData="dbRowData"
                    @fetch="fetch"
                    @updateEnd="updateEnd"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import BaseInputPagination from "@/components/form/BaseInputPagination";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import BaseIcon from "@/components/BaseIcon";
import template from "./template";
import Edit from "@/components/fattutto/configuration/details/Edit";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "FattuttoConfigurationTableRef",
  extends: template,
  data() {
    return {
      customModalClass: "modal-fattutto-configuration",
      custoModalTitle: "Modifica entità per flusso contabilità fiscale",
      tabs: [{name: "Edit", text: "Edit"}],
      selected: "Edit",
      modalResourceId: null,
      dbRowData: null, // tab Contraente deve avere i dati della polizza per Voltura
      tabIndex: 0,
      fattutto_entity_code: "configurable.code",
    };
  },
  components: {
    ButtonGroupTab,
    BaseIcon,
    BaseInputPagination,
    Edit,
    EmptyTable,
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    automaticPerformedSearch: {
      type: Boolean,
      default: false
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newFattuttoConfigBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateEnd() {
      this.$emit("forcedFetch");
      this.$bvModal.hide("modal");
    },
    // createTrasmission(item) {
    //   this.isLoading = true;
    //   const Repo = RepositoryFactory.get("fattutto");
    //   const payload = {
    //     date: item.consolidated_at,
    //   };
    //   Repo.create_transmission(payload)
    //     .then(() => {
    //       this.$emit("transmissionActionsEnd");
    //       this.$showSnackbar({
    //         preset: "success",
    //         text: `Azione Completata: Trasmissione Creata`,
    //       });
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({
    //         preset: "error",
    //         text: `${errMsg}`,
    //       });
    //     });
    //   // .finally(() => {
    //   //   this.isLoading = false;
    //   // });
    // },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewFattuttoConfig() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    renderEntityCode(item) {
      if (!item.configurable) return "-";
      let ret = "";
      switch (item.configurable_type) {
        case "App\\Models\\Insurer":
          ret = `${item.configurable.code} - ${item.configurable.title}`;
          break;
        case "App\\Models\\Broker":
          ret = `${item.configurable.attributables.BUID}${
              item.configurable?.attributables?.SURN
                  ? ` - ${item.configurable.attributables.SURN}`
                  : ""
          } ${
              item.configurable?.attributables?.NAME
                  ? ` ${item.configurable.attributables.NAME}`
                  : ""
          }`;
          break;
        case "App\\Models\\VariousAccounting":
          ret = `${item.configurable.code} - ${item.configurable.title}`;
          break;
        case "App\\Models\\Sector":
          ret = `${item.configurable.code} - ${item.configurable.title}`;
          break;
        default:
          console.log("No configurable_type matched!");
          break;
      }
      return ret;
    },
    getNestedValue(obj, path) {
      return path
          .split(".")
          .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
    },
    rowClass(item) {
      if (!item || item?.active == null) return "";
      if (item.active) return "configuration-1";
      return "configuration-2";
    },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    fattuttoEntityCode() {
      return `cell(${this.fattutto_entity_code})`;
    },
  },
  // beforeMount() {
  //   this.actions.push("infomodal");
  // },
};
</script>

<style lang="scss" scoped>
/* ROSSO */
:deep(.configuration-2 td:nth-child(2)) {
  background: inherit !important;
  border-left: 5px solid rgba(228, 33, 33, 0.3) !important;
}

/* VERDE */
:deep(.configuration-1 td:nth-child(2)) {
  background: inherit !important;
  border-left: 5px solid rgba(19, 172, 19, 0.4) !important;
}

/* NEUTRO */
:deep(.configuration-0 td:nth-child(2)) {
  background: inherit !important;
}
</style>
